import { kebabCase } from 'lodash';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import {
  dailyMaximums,
  ExchangeType,
  EXISTING_ICLASS_FUND_MIN_AMOUNT,
  NEW_ICLASS_FUND_MIN_AMOUNT,
  ZERO_FUND_NON_RETIREMENT,
  ZERO_FUND_RETIREMENT,
} from '../../../../settings/settings';
import ExpandedFundHeader from './ExpandedFundHeader';
import FastEqualComponent from '../../../FastEqualComponent/FastEqualComponent';
import MarketVolatilityNote from './MarketVolatilityNote';
import {
  getFundMinimum,
  getMismatchBusinessParty,
} from '../../../../utils/funds/funds-utility';
import { isIRA } from '../../../../utils/IRA/IRA-utility';
import {
  isClosedFund,
  isNewIClassFund,
  isNewOrReopenIClassFund,
} from '../../../../utils/funds/shared/shared-fund-notes-utility';
import {
  clearStudentId,
  updateStudentIdEnable,
} from '../../../../redux/modules/studentDetail';
import {
  isAutoExchange,
  isCollegeDistribute,
  isCollegeExchange,
  isExchange,
  isRecurringBuy,
  isRecurringBuyEdit,
  isRothConversion,
} from '../../../../utils/transactions-util';
import ClosedFundEligibleMessage from './InlineClosedFundEligibleMessage';
import NewIClassMinBalanceMessage from './InlineNewIClassMinBalanceMessage';
import IClassSwapInlineMessage from './IClassSwapInlineMessage';
import FundConversionThresholdInlineMessage from './FundConversionThresholdInlineMessage';
import If from '../../../Shared/If/If';
import styles from './ExpandedFund.module.scss';
import classNames from 'classnames';
import {
  DELIVERY_IN_KIND,
  DELIVERY_MAIL_CHECK_TO_SCHOOL,
} from 'src/settings/settings';
import {
  CONFIRM_IRA_DISTRIBUTION_MODAL,
  EXCHANGE_RETIREMENT_AGREEMENT,
} from '../../../../redux/modules/modals/modals.module';
import { isAPP } from '../../../../utils/advice/advice-utility';
import { getPOAIraLimit } from '../../../../redux/modules/funds/IRALimitSearch/IRALimitSearch.module';

class ExpandedFund extends FastEqualComponent {
  constructor(props) {
    super(props);
    this.toggleFundChecked = this.toggleFundChecked.bind(this);
    this.state = {
      showConfirmModal: true,
    };
  }
  toggleFundChecked(fund) {
    const {
      currentStep,
      fromFundTotalAmount,
      actions: { openModal, deselectFund, selectFund },
      exchangeFromFunds,
      personalData = {},
      handleUpdateStudentIdEnable,
      handleClearStudentId,
      getPOALimit,
      deliveryMethod,
    } = this.props;

    function handleChecked() {
      if (fund.disabled) {
        return;
      }
      const { agreementID, BPID } = fund;
      if (fund.selected && !isRothConversion()) {
        deselectFund(agreementID, BPID);
        if (deliveryMethod === DELIVERY_MAIL_CHECK_TO_SCHOOL) {
          handleUpdateStudentIdEnable(fund);
        }
      } else {
        selectFund(agreementID, fund, BPID); // sell has additional logic that needs fund, ignored by buy
        if (deliveryMethod === DELIVERY_MAIL_CHECK_TO_SCHOOL) {
          handleClearStudentId(fund);
        }
        const po = getMismatchBusinessParty(fund, personalData);
        const isIRAFund = isIRA(fund);
        if (po && isIRAFund) {
          getPOALimit(po.businessPartyID);
        }
      }
    }
    //non-retirement ($2500) or retirement ($1000) agreement or iClass and either 50k or 500k
    const minimumExchangeAmountFor0DollarFund =
      fund.displayClassification === 'NON_RETIREMENT'
        ? ZERO_FUND_NON_RETIREMENT
        : ZERO_FUND_RETIREMENT;
    if (
      fund.balanceAsOf === 0 &&
      currentStep === 2 &&
      fromFundTotalAmount < minimumExchangeAmountFor0DollarFund &&
      isExchange()
    ) {
      openModal(EXCHANGE_RETIREMENT_AGREEMENT, {
        fund,
      });
    } else if (
      fund.balanceAsOf === 0 &&
      currentStep === 2 &&
      fund.iClass &&
      (((fund?.household?.householdBalanceTierStatus.householdAssetTier
        ?.name === 'Personal Services' ||
        fund?.household?.householdBalanceTierStatus.householdAssetTier?.name ===
          'Enhanced Personal Services') &&
        fromFundTotalAmount < 50000) ||
        (fund?.household?.householdBalanceTierStatus?.householdAssetTier
          ?.name !== 'Personal Services' &&
          fund?.household?.householdBalanceTierStatus?.householdAssetTier
            ?.name !== 'Enhanced Personal Services' &&
          fromFundTotalAmount < 500000))
    ) {
      openModal(EXCHANGE_RETIREMENT_AGREEMENT, {
        fund,
      });
    } else if (
      currentStep === 2 &&
      fund.displayClassification === 'NON_RETIREMENT' &&
      (isExchange() || isAutoExchange()) &&
      this.state.showConfirmModal &&
      isIRA(exchangeFromFunds[0])
    ) {
      this.setState({ showConfirmModal: false });
      openModal(CONFIRM_IRA_DISTRIBUTION_MODAL, {
        fund,
        proceed: handleChecked,
      });
    } else {
      handleChecked();
    }
  }
  static fundSelectedClassName({ disabled, selected }) {
    return classNames(
      { disabled: disabled },
      { selected: !disabled && selected },
      { unselected: !disabled && !selected }
    );
  }

  /**
   * Will check if balance allotted to newly added fund meets 50k min (based on exchange or buy)
     if Exchange, will need to check between Exchange one to one, or Exchange one to many
   * @param {Fund} fund
   * @param {*} fundType
   * @param {Fund} selectedExchangeFund
   * @returns {boolean}
   */
  displayIClassMinBalanceMessage(fund, fundType, exchangeFromFunds) {
    if (isExchange() && exchangeFromFunds) {
      // get sum of exchange from funds
      const exchangeGrossAmount = exchangeFromFunds.reduce(
        (acc, fund) => acc + fund.grossAmountDollars,
        0
      );

      // if ONE_TO_MANY, check the inputed amount to fund
      // if ..._TO_ONE, check the total exchange from amount from funds in step 1
      return fundType === ExchangeType['ONE_TO_MANY']
        ? fund.grossAmount < NEW_ICLASS_FUND_MIN_AMOUNT
        : exchangeGrossAmount < NEW_ICLASS_FUND_MIN_AMOUNT;
    }

    return fund.currentYearAmount < NEW_ICLASS_FUND_MIN_AMOUNT;
  }

  /**
   * Decide whether or not to display IClass Swap button
   * @param {Fund} fund
   * @param {Fund[]} exchangeFromFunds
   * @param {Fund} iClassVer
   */
  displayIClassSwapButton(fund, exchangeFromFunds, iClassVer, userFunds) {
    // will need to be newly added non-iclass fund
    if (
      !fund.newFund ||
      fund.iClass ||
      !iClassVer ||
      (fund.newFund &&
        (!!userFunds?.funds[0]?.nonRetirementAgreements[
          fund.agreementType
        ]?.find(
          (fnd) =>
            fnd.agreementType === fund.agreementType &&
            fnd.fundName === `${fund.fundName} - I Class` &&
            fnd.fundType === 'ICLASS'
        ) ||
          !!userFunds?.funds[0]?.retirementAgreements[fund.agreementType]?.find(
            (fnd) =>
              fnd.agreementType === fund.agreementType &&
              fnd.fundName === `${fund.fundName} - I Class` &&
              fnd.fundType === 'ICLASS'
          ))) ||
      (isExchange() && !iClassVer.exchangeAllowed)
    ) {
      return false;
    }

    // check amount inputted
    const grossAmount = isExchange()
      ? exchangeFromFunds.reduce(
          (acc, fund) => acc + fund.grossAmountDollars,
          0
        )
      : fund.currentYearAmount;

    return grossAmount >= NEW_ICLASS_FUND_MIN_AMOUNT;
  }

  /**
   * Extract correct household information for current fund based on if newly added or not
   * Household info used to keep track of iclass or closed fund access for owner of fund
   * @param {Fund}
   * @param {Household} userHousehold
   */
  getHouseholdInfo({ household, agreementKeyHouseholds }) {
    const defaultHouseholdProps = {
      IClassFundAccess: false,
      closedFundAccess: false,
    };

    // if newly added fund, use the household of agreement used to add the fund
    // else look for existing household associated with fund or fallback to default
    const householdInfo = agreementKeyHouseholds
      ? agreementKeyHouseholds[0].household
      : household;

    return householdInfo
      ? householdInfo.householdBalanceTierStatus.householdAssetTier
      : defaultHouseholdProps;
  }

  /**
   * Checks if an existing fund is within the threshold for an iclass conversion to
   * to show a message to the user
   * @param {Fund} fund
   * @param {Fund} iClassVersion
   * @return {boolean}
   */
  displayFundThresholdConversionMessage(fund, iClassVersion) {
    const { newFund, iClass, balanceAsOf } = fund;
    return (
      !newFund &&
      !iClass &&
      iClassVersion &&
      this.isWithinFundThresholdConversion(balanceAsOf)
    );
  }

  /**
   * Checks if fund's balance is within the conversion alert threshold
   * @param {number} balanceAsOf
   * @return {boolean}
   */
  isWithinFundThresholdConversion(balanceAsOf) {
    return (
      Math.abs(NEW_ICLASS_FUND_MIN_AMOUNT - balanceAsOf) <= 5000 &&
      balanceAsOf < NEW_ICLASS_FUND_MIN_AMOUNT
    );
  }

  render() {
    const {
      customerWebViewEnabled,
      isSalesforceRep,
      actions,
      availableFunds,
      currentYearInclusiveRemainingContributions,
      currentStep,
      deliveryMethod,
      displayTradeDate,
      exchangeFromFunds,
      exchangeFromTotalDollars,
      firstOfAgreement,
      fund,
      fundEditor: FundEditor,
      fundIndex,
      hasNotInheritedSEPOrSimpleIRA,
      hasAPP,
      iClassVersion,
      IRALimit,
      isManySelect,
      IRALimitSearchByPoid,
      marketVolatility,
      nonRetirementMaxLimit,
      personalData,
      priorYearInclusiveRemainingContributions,
      RMData,
      transactionLimit,
      userAddress,
      userFunds,
      windowCutoffDate,
      selectedFund,
      eligibleForRMD,
      fundType,
      ...passthrough
    } = this.props;

    const fundClassName = kebabCase(fund.fundName);
    const lastFund = availableFunds[fundIndex - 1];

    // if adding a new iclass, minimum balance of $50,000 if the ICLass already exists its $100
    const minValue = isNewOrReopenIClassFund(fund)
      ? NEW_ICLASS_FUND_MIN_AMOUNT
      : fund.fundType === 'ICLASS'
      ? EXISTING_ICLASS_FUND_MIN_AMOUNT
      : getFundMinimum(fund, 'currentYearLimit');
    const expandedFundClassName = ExpandedFund.fundSelectedClassName(fund);
    const lastFundClassName =
      lastFund && ExpandedFund.fundSelectedClassName(lastFund);
    const outerClasses = classNames(
      'expanded-fund-fund-row-container',
      `fund-agreement-${fund.agreementID}`, // used in scroll from NewFundSearch
      `expanded-fund-${expandedFundClassName}`,
      styles[`expanded-fund-${expandedFundClassName}`],
      {
        [styles[`expanded-fund-last-${lastFundClassName}`]]: lastFund,
      },

      'e2e-row-fund',
      `e2e-${kebabCase(fund.displayClassification)}-fund`,
      `e2e-${kebabCase(fund.agreementType)}-fund`
    );
    const maxValue = isIRA(fund)
      ? fund.currentYearMaximumLimit
      : fund.agreementType === 'COLLEGE_SAVINGS' && isRecurringBuy()
      ? dailyMaximums.recurring.college_buy
      : nonRetirementMaxLimit;

    const editorProps = {
      ...passthrough,
      customerWebViewEnabled,
      isSalesforceRep,
      actions,
      currentYearInclusiveRemainingContributions,
      deliveryMethod,
      displayTradeDate,
      exchangeFromTotalDollars,
      fund,
      fundType,
      fundClassName,
      fundIndex,
      hasAPP,
      hasNotInheritedSEPOrSimpleIRA,
      IRALimit,
      isManySelect,
      IRALimitSearchByPoid,
      marketVolatility,
      maxValue,
      minValue,
      personalData,
      priorYearInclusiveRemainingContributions,
      RMData,
      transactionLimit,
      userAddress,
      userFunds,
      windowCutoffDate,
    };

    // Check if household information is available, if not dont show any scs functionality
    const householdTier = this.getHouseholdInfo(fund);

    const isShowClosedFundEligibleMessage =
      isClosedFund(fund) &&
      fund.balanceAsOf === 0 &&
      !fund.merged &&
      currentStep === 2 &&
      fund.agreementType !== 'COLLEGE_SAVINGS';

    const showClosedFundEligibleMessage =
      (fund.purchaseBlocked || !fund?.fundLock?.fundLocked) &&
      isShowClosedFundEligibleMessage
        ? isShowClosedFundEligibleMessage &&
          !fund.purchaseBlocked &&
          !fund?.fundLock?.fundLocked
        : isShowClosedFundEligibleMessage;

    // If new iClass fund, Will check if balance allotted to newly added fund meets 50k min (based on exchange or buy)
    const showNewIClassMinBalanceMessage =
      isNewIClassFund(fund) &&
      currentStep === 2 &&
      this.displayIClassMinBalanceMessage(fund, fundType, exchangeFromFunds) &&
      fund.agreementType !== 'COLLEGE_SAVINGS';

    /*
      If newly added regular fund and user is tier 4 (iclass access) and up
      decide whether or not to show iclass swap button
      Will need to be at least 50k inputted and have an iclass version of fund available
    */
    const showIClassSwapButton =
      currentStep === 2 &&
      householdTier.IClassFundAccess &&
      this.displayIClassSwapButton(
        fund,
        exchangeFromFunds,
        iClassVersion,
        userFunds
      ) &&
      fund.agreementType !== 'COLLEGE_SAVINGS';

    const swapIClassCallback = isExchange()
      ? actions.swapExchangeToFund
      : actions.swapFund;

    const showFundConversionThresholdMessage =
      currentStep === 2 &&
      householdTier.IClassFundAccess &&
      this.displayFundThresholdConversionMessage(fund, iClassVersion) &&
      fund.agreementType !== 'COLLEGE_SAVINGS';
    return (
      <div className={outerClasses}>
        <ExpandedFundHeader
          actions={actions}
          firstOfAgreement={firstOfAgreement}
          fund={fund}
          fundClassName={fundClassName}
          fundDisabled={fund.disabled}
          fundIndex={fundIndex}
          isCheckbox={isManySelect}
          toggleFundChecked={this.toggleFundChecked}
          selectedFund={selectedFund}
          eligibleForRMD={eligibleForRMD}
          fundType={fundType}
        />
        {(isRecurringBuyEdit() || fund.selected) &&
          FundEditor &&
          deliveryMethod !== DELIVERY_IN_KIND && (
            <FundEditor {...editorProps} />
          )}
        {(isCollegeExchange() || isCollegeDistribute()) &&
          fund.selected &&
          !isAPP(fund.productType) &&
          marketVolatility?.displayVolatilityMessage && (
            <Fragment>
              <If test={!isExchange()}>
                {!customerWebViewEnabled && isSalesforceRep ? (
                  <span></span>
                ) : (
                  <span>
                    <div
                      className={
                        styles['expanded-fund-volatility-note-container']
                      }
                    >
                      <MarketVolatilityNote />
                    </div>
                  </span>
                )}
              </If>
            </Fragment>
          )}
        {showClosedFundEligibleMessage && (
          <ClosedFundEligibleMessage
            isEligible={householdTier.closedFundAccess}
            isExchange={isExchange()}
          />
        )}
        {showNewIClassMinBalanceMessage && <NewIClassMinBalanceMessage />}
        {showIClassSwapButton && (
          <IClassSwapInlineMessage
            fundName={fund.name}
            onClick={() =>
              swapIClassCallback(fund.agreementID, {
                ...fund,
                ...iClassVersion,
                fundName: iClassVersion.name,
              })
            }
          />
        )}
        {showFundConversionThresholdMessage && (
          <FundConversionThresholdInlineMessage
            fund={fund}
            iClassVersion={iClassVersion}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = (dispatch) => ({
  handleUpdateStudentIdEnable: (fund) => dispatch(updateStudentIdEnable(fund)),
  handleClearStudentId: (fund) => dispatch(clearStudentId(fund)),
  getPOALimit: (bpid) => dispatch(getPOAIraLimit(bpid)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExpandedFund);
